<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">
          <div class="col-12 col-lg-6 my-3 my-md-5 img-carousel">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-lg-6 my-3 my-md-5">
            <div v-stick-in-parent>
              <!-- START SINGLEITEM_DETAILS -->

              <div class="mb-2">
                <span class="articlenumber">{{ $translate("Ceres::Template.singleItemNumber") }} {{ currentVariation.item.id }}</span>
              </div>

              <h1 class="h2 title" data-testing="item-name">
                <span>
                  {{ currentVariation | itemName }}
                </span>
                <div class="img-addition d-inline-block">
                  <div v-if="hasProp72Summer">
                    <img :src="$translate('RZOVueJSTheme::Single.summer')" class="img-fluid" alt="Sommerreifen" />
                  </div>
                  <div v-if="hasProp72Winter">
                    <img :src="$translate('RZOVueJSTheme::Single.winter')" class="img-fluid" alt="Winterreifen" />
                  </div>
                  <div v-if="hasProp72AllRad">
                    <img :src="$translate('RZOVueJSTheme::Single.allRad')" class="img-fluid" alt="Allwetterreifen" />
                  </div>
                </div>
              </h1>

              <!-- Badges
                <slot name="tag-list"></slot>
              -->

              <!-- ITEM DESCRIPTION -->
              <div class="my-5">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" v-if="isDescriptionTabActive || hasGroupId3">
                    <a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
                  </li>

                  <slot name="fs-accessory-tab"></slot>

                  <li class="nav-item">
                    <a
                      :class="{ active: !isDescriptionTabActive && isTechnicalDataTabActive && !hasGroupId3 }"
                      class="nav-link"
                      data-toggle="tab"
                      :href="'#data-' + currentVariation.variation.id"
                      role="tab"
                      data-plim="BitteBeachtenTab"
                      >{{ $translate("Ceres::Template.singleItemTechnicalData") }}</a
                    >
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#service-details" role="tab" data-plim="beratungTab">{{ $translate("RZOVueJSTheme::Single.service") }}</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#guarantee-details" role="tab" data-plim="aenderungswuenscheTab">{{ $translate("RZOVueJSTheme::Single.guarantee") }}</a>
                  </li>

                  <slot name="add-detail-tabs"></slot>
                </ul>

                <div class="tab-content overflow-hidden">
                  <div class="tab-pane active overflow-hidden fs-description" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive || hasGroupId3">
                    <template v-if="hasGroupId3">
                      <table class="prop-data my-4">
                        <tbody>
                          <template v-for="property in propertyGroupList">
                            <tr class="d-flex" v-if="property.values.value != '' && property.id != 81 && property.id != 14 && property.id != 15 && property.id != 65">
                              <td class="name" v-html="property.names.name"></td>
                              <td class="value" v-html="property.values.value"></td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </template>
                    <template v-else>
                      <div class="my-4 description" v-html="currentVariation.texts.description"></div>
                    </template>
                  </div>

                  <div class="tab-pane" id="fs-accessory" role="tabpanel" data-plim="ZubehoerItemsContent">
                    <div class="my-4">
                      <slot name="fs-accessory"></slot>
                    </div>
                  </div>

                  <div
                    :class="{ active: !isDescriptionTabActive && isTechnicalDataTabActive && !hasGroupId3 }"
                    class="tab-pane overflow-auto"
                    :id="'data-' + currentVariation.variation.id"
                    role="tabpanel"
                    v-if="isTechnicalDataTabActive"
                    data-plim="BitteBeachtenContent"
                  >
                    <template v-if="hasProp81">
                      <div class="my-4 beachten-slot">
                        <slot name="beachten-description"></slot>
                      </div>
                    </template>
                    <template v-else>
                      <div class="my-4 beachten-old" v-html="currentVariation.texts.technicalData"></div>
                    </template>
                  </div>

                  <div class="tab-pane overflow-auto" id="service-details" role="tabpanel" data-plim="beratungContent">
                    <div class="my-4">
                      <slot name="servicecat-description"></slot>
                    </div>
                  </div>

                  <div class="tab-pane overflow-auto" id="guarantee-details" role="tabpanel" data-plim="aenderungswuenscheContent">
                    <div class="my-4">
                      <slot name="guaranteecat-description"></slot>
                    </div>
                  </div>

                  <slot name="add-detail-tabs-content"></slot>
                </div>
              </div>
              <!-- ./ITEM DESCRIPTION -->

              <!-- Variation -->
              <div class="v-select" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <div class="fs-pricebox d-flex flex-wrap p-3">
                <div class="fs-itemusp d-flex flex-wrap order-2 order-xl-1 mt-4 mt-xl-0">
                  <div class="item d-flex mb-3 mr-3">
                    <img :src="$translate('RZOVueJSTheme::SingleUSPs.usp1Icon')" class="img-fluid mr-2" :alt="$translate('RZOVueJSTheme::SingleUSPs.usp1Head')" />
                    <div>
                      <p class="font-weight-bold m-0 font-usuzi text-uppercase">{{ $translate("RZOVueJSTheme::SingleUSPs.usp1Head") }}</p>
                      <p class="m-0">{{ $translate("RZOVueJSTheme::SingleUSPs.usp1Text") }}</p>
                    </div>
                  </div>

                  <div class="item d-flex mb-3 mr-3">
                    <img :src="$translate('RZOVueJSTheme::SingleUSPs.usp2Icon')" class="img-fluid mr-2" :alt="$translate('RZOVueJSTheme::SingleUSPs.usp2Head')" />
                    <div>
                      <p class="font-weight-bold m-0 font-usuzi text-uppercase">{{ $translate("RZOVueJSTheme::SingleUSPs.usp2Head") }}</p>
                      <p class="m-0">{{ $translate("RZOVueJSTheme::SingleUSPs.usp2Text") }}</p>
                    </div>
                  </div>

                  <div class="item d-flex mb-3 mb-xl-5 mr-3">
                    <img :src="$translate('RZOVueJSTheme::SingleUSPs.usp3Icon')" class="img-fluid mr-2" :alt="$translate('RZOVueJSTheme::SingleUSPs.usp3Head')" />
                    <div>
                      <p class="font-weight-bold m-0 font-usuzi text-uppercase">{{ $translate("RZOVueJSTheme::SingleUSPs.usp3Head") }}</p>
                      <p class="m-0">{{ $translate("RZOVueJSTheme::SingleUSPs.usp3Text") }}</p>
                    </div>
                  </div>

                  <div class="fs-wishlist mr-3">
                    <div v-if="isWishListEnabled" class="row">
                      <div class="col-12">
                        <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="fs-rightside d-flex ml-md-3 justify-content-between order-1 order-xl-2 flex-wrap">
                  <div class="fs-shortage d-flex align-self-start" v-if="currentVariation.stock.net < stockNumber && currentVariation.stock.net > 0 && showStockWarning == 'true'">
                    <div class="alert mb-0 p-2 d-inline-block">
                      <p class="font-weight-bold m-0 font-usuzi text-uppercase">{{ $translate("RZOVueJSTheme::Single.shortageHead") }}</p>
                      <p class="m-0">{{ $translate("RZOVueJSTheme::Single.shortageText") }}</p>
                    </div>
                  </div>

                  <div class="fs-calc d-flex flex-column align-items-end justify-content-end mt-3 mt-md-0">
                    <slot name="before-price"></slot>

                    <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                      <order-property-list></order-property-list>
                    </div>

                    <graduated-prices></graduated-prices>

                    <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                    <slot name="after-price"></slot>

                    <div class="text-right">
                      <span class="vat small text-muted d-block">
                        {{ $translate("Ceres::Template.singleItemFootnote1") }}
                        <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template>
                        <template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}
                        <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                        <a v-else>{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                      </span>
                      <item-availability></item-availability>
                    </div>
                  </div>
                  <div class="mb-1 w-100 d-flex button-wrap">
                    <div class="w-100">
                      <slot name="before-add-to-basket"></slot>
                    </div>

                    <div class="w-100 text-right"></div>
                    <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                      {{ $translate("Ceres::Template.singleItemSetInfo") }}
                    </div>
                    <div v-else class="col-12 px-0">
                      <add-to-basket
                        :variation-id="currentVariation.variation.id"
                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                        :maximum-quantity="
                          !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                        "
                        :order-properties="
                          currentVariation.properties.filter(function(prop) {
                            return prop.property.isOderProperty;
                          })
                        "
                        :has-order-properties="currentVariation.hasOrderProperties"
                        :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                        :use-large-scale="false"
                        :show-quantity="true"
                        :item-url="currentVariation | itemURL"
                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                        :has-price="currentVariation | hasItemDefaultPrice"
                      >
                      </add-to-basket>
                    </div>

                    <div class="w-100">
                      <slot name="after-add-to-basket"></slot>
                    </div>
                  </div>
                  <slot name="additional-content-after-vat"></slot>
                </div>
              </div>

              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>
        </div>
      </div>
      <!-- end singlitem-->

      <div class="container-fluid fs-seo" v-if="currentVariation.texts.shortDescription !== ''">
        <div class="container-max mt-4">
          <div class="single-description row" v-html="currentVariation.texts.shortDescription"></div>
        </div>
      </div>

      <div class="container-fluid fs-list-container">
        <div class="container-max">
          <slot name="item-list-container"></slot>
        </div>
      </div>

      <slot name="fs-questions"></slot>

      <slot name="feedback-container"></slot>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  data() {
    return {
      propertyGroupList: [],
    };
  },

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  computed: {
    hasGroupId3() {
      if (this.currentVariation.variationProperties) {
        let propertiesArr = [];
        for (let propertyGroup of this.currentVariation.variationProperties) {
          propertiesArr = propertiesArr.concat(propertyGroup.properties);
        }
        this.propertyGroupList = propertiesArr.sort(function(a, b) {
          return a.position - b.position;
        });
        return true;
      }
      return false;
    },

    hasProp81() {
      if (this.currentVariation.variationProperties) {
        let result = null;

        for (let property of this.currentVariation.variationProperties) {
          result = property.properties.find((prop) => {
            return prop.id === 81;
          });

          if (!isNullOrUndefined(result)) {
            return true;
          }
        }
      }
      return false;
    },

    showStockWarning() {
      return App.themeConfig.showStockWarning;
    },
    stockNumber() {
      return App.themeConfig.stockNumber;
    },

    itemConfig() {
      return App.config.item.itemData;
    },

    hasProp72AllRad() {
      return this.hasProp72WithSelection(10);
    },

    hasProp72Winter() {
      return this.hasProp72WithSelection(9);
    },

    hasProp72Summer() {
      return this.hasProp72WithSelection(8);
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });
    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  sortProperties() {
    return properties.sort((prev, current) => {
      if (prev.position > current.position) {
        return 1;
      }
      if (prev.position < current.position) {
        return -1;
      }

      return 0;
    });
  },

  methods: {
    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },

    hasProp72WithSelection(selectionId) {
      if (this.currentVariation.variationProperties) {
        let result = null;

        for (let property of this.currentVariation.variationProperties) {
          result = property.properties.find((prop) => {
            return prop.id === 31 && prop.values.selectionId === selectionId;
          });

          if (!isNullOrUndefined(result)) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>
